export const formatCurrency = (
  amount: number,
  currencyCode: string = 'USD',
  currencySymbol: string = '$'
): string => {
  try {
    // Convert to number if it's a string
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    
    // Check if it's a valid number
    if (isNaN(numAmount)) {
      console.log('formatCurrency: Invalid amount', amount);
      return `${currencySymbol}0.00`;
    }
    
    // Manual formatting for better React Native compatibility
    // Format number with 2 decimal places
    const fixedAmount = numAmount.toFixed(2);
    
    // Add thousands separators
    const [integerPart, decimalPart] = fixedAmount.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    const result = `${currencySymbol}${formattedInteger}.${decimalPart}`;
    console.log('formatCurrency:', { amount, numAmount, result });
    
    return result;
  } catch (error) {
    console.error('formatCurrency error:', error);
    return `${currencySymbol}${amount}`;
  }
};

export const parseCurrencyInput = (input: string): number => {
  // Remove all non-numeric characters except decimal point
  const cleaned = input.replace(/[^0-9.]/g, '');
  
  // Ensure only one decimal point
  const parts = cleaned.split('.');
  if (parts.length > 2) {
    return parseFloat(parts[0] + '.' + parts.slice(1).join(''));
  }
  
  return parseFloat(cleaned) || 0;
}; 